"use strict";

var _toConsumableArray = require("@babel/runtime/helpers/toConsumableArray");
var _toArray = require("@babel/runtime/helpers/toArray");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.concat.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return resolveConfig;
  }
});
var _resolveConfig = /*#__PURE__*/_interop_require_default(require("../util/resolveConfig"));
var _getAllConfigs = /*#__PURE__*/_interop_require_default(require("../util/getAllConfigs"));
function _interop_require_default(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function resolveConfig() {
  for (var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }
  var _ref = (0, _getAllConfigs.default)(configs[0]),
    _ref2 = _toArray(_ref),
    defaultConfigs = _ref2.slice(1);
  return (0, _resolveConfig.default)([].concat(configs, _toConsumableArray(defaultConfigs)));
}